export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6328.5ea32f6e.jpg";